<app-integration
    [widgetRef]="widgetRef"
    [integrationInput]="integrationInput"
    [isConfigured]="isConfigured"
    (onIntegrate)="onIntegrate()"
></app-integration>
